module.exports = __webpack_public_path__ + "5e3349f37a8a446c11b3f149dcbe497a.png";